export default __webpack_public_path__ + "locales/hy-AM/Common.json?hash=d4aac9777486ea189bd2fd09cb38622f";